<script lang="ts">
  import type { Snippet } from 'svelte';
  import type { TaskData } from '../lib/tasks';
  import CaseNumberCard from './MatterCard/CaseNumberCard.svelte';
  import TaskList from './MatterCard/TaskList.svelte';
  import ProgressRefresh from './ProgressRefresh.svelte';

  let {
    title,
    badges,
    case_number,
    stage,
    tasks,
    image,
    ts = null,
    children
  } : {
    title : string;
    badges : {label : string; value : string; mobile : boolean}[];
    case_number? : string;
    stage? : string;
    tasks : TaskData[];
    image? : Snippet;
    ts? : number;
    children : Snippet;
  } = $props()

  const NON_BREAKING_HYPHEN = "‑"
  const NON_BREAKING_SPACE = " "
  function formatTitle(title: string) {
    return title
      .replace(/-/g, NON_BREAKING_HYPHEN) // Don't wrap on "-" as in "CR-V"
      .replace(/ (?=\S{1,7}$)/, NON_BREAKING_SPACE) // Prevent orphans less than 8 chars long
  }
</script>

<CaseNumberCard {case_number} {stage}>
  <div class="rounded bg-white p-4 lg:p-6 flex flex-col gap-2 relative">
    <div class="overflow-visible mb-2 lg:mb-4">
      <div class="flex items-center justify-between">
        <h2 class="grow ui-section-title m-0 lg:text-2xl !leading-[1.625rem] text-ellipsis {image ? "line-clamp-3" : "line-clamp-2"}">
          {formatTitle(title)}
        </h2>
        {@render image?.()}
      </div>
      {#if badges.length}<div class="hidden lg:block">{@render badgesList()}</div>{/if}
    </div>
    {#if children}
      {@render children()}
    {:else}
      <TaskList {tasks} />
    {/if}
    {#if badges.length}
      <div class="lg:hidden grid-cols-[1fr_max-content] grid items-center -mb-1 -mx-2">
        {@render badgesList({mobile: true})}
      </div>
    {/if}
    {#key ts}<ProgressRefresh noun="claim" channel={case_number} {ts} class="[body:has(dialog[open])_&]:hidden" />{/key}
  </div>
</CaseNumberCard>

{#snippet h2({mobile}={mobile: false})}
  <h2 class:mb-2={!mobile} class:text-xl={mobile} class:lg:hidden={mobile} class="ui-title leading-[1.625rem] py-[1px] text-ellipsis line-clamp-2">
    {formatTitle(title)}
  </h2>
{/snippet}

{#snippet badgesList({mobile} = {mobile: false})}
  <div class={`flex flex-wrap gap-1 ${mobile ? "min-w-0 pt-2 pb-1" : ""}`}>
    {#each badges as badge (badge.label)}
      {#if mobile || !badge.mobile}
        <span class="badge badge-ghost inline-block whitespace-nowrap overflow-hidden text-nowrap text-ellipsis max-w-full">
          {badge.label}: {badge.value}
        </span>
      {/if}
    {/each}
  </div>
{/snippet}
